import { Panel } from 'component/Space/Panel'
import { observer } from 'mobx-react-lite'
import { Mode } from 'page/ProfileScreen/Modes/Mode'
import { opt } from 'store/opt'

export const Modes = observer(() => {
  const { body } = opt

  return <Panel auto>
    {body.includes(0) && <Mode mode={0} />}
    {body.includes(1) && <Mode mode={1} />}
    {body.includes(2) && <Mode mode={2} />}
  </Panel>
})
